// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.employment-eligibility-container {
  .pending {
    color: #eca300;
    display: flex;
    width: 74px;
    height: 26px;
    border-radius: 18px;
    background: #fcf6d6;
    justify-content: center;
    align-items: center;
  }
  .passed {
    color: #60a546;
    display: flex;
    width: 74px;
    height: 26px;
    border-radius: 18px;
    background: #e0ebdf;
    justify-content: center;
    align-items: center;
  }
  .failed {
    color: #dc1515;
    display: flex;
    width: 74px;
    height: 26px;
    border-radius: 18px;
    background: #ffe1e1;
    justify-content: center;
    align-items: center;
  }
}

.reset-employment-eligibility-modal-form {
  .reset-employment-eligibility-modal-body {
    .sub-heading {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      gap: 12px;
      align-items: center;
      margin-bottom: 12px;
      .eligibility-unverified-icon {
        color: red;
        width: 24px;
        height: 24px;
      }
      .sub-heading-text {
        color: var(--Cod-Gray, #1c1c1c);
        font-size: 16px;
        font-weight: 700;
      }
    }
    .sub-heading-message {
      margin-bottom: 24px;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%; /* 24px */
      letter-spacing: 0.15px;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/routes/Agency/Worker/shared/ProfileCard/EmploymentEligibility/index.css"],"names":[],"mappings":"AAAA;EACE;IACE,cAAc;IACd,aAAa;IACb,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,aAAa;IACb,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,aAAa;IACb,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE;MACE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,SAAS;MACT,mBAAmB;MACnB,mBAAmB;MACnB;QACE,UAAU;QACV,WAAW;QACX,YAAY;MACd;MACA;QACE,+BAA+B;QAC/B,eAAe;QACf,gBAAgB;MAClB;IACF;IACA;MACE,mBAAmB;MACnB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB,EAAE,SAAS;MAC5B,sBAAsB;IACxB;EACF;AACF","sourcesContent":[".employment-eligibility-container {\n  .pending {\n    color: #eca300;\n    display: flex;\n    width: 74px;\n    height: 26px;\n    border-radius: 18px;\n    background: #fcf6d6;\n    justify-content: center;\n    align-items: center;\n  }\n  .passed {\n    color: #60a546;\n    display: flex;\n    width: 74px;\n    height: 26px;\n    border-radius: 18px;\n    background: #e0ebdf;\n    justify-content: center;\n    align-items: center;\n  }\n  .failed {\n    color: #dc1515;\n    display: flex;\n    width: 74px;\n    height: 26px;\n    border-radius: 18px;\n    background: #ffe1e1;\n    justify-content: center;\n    align-items: center;\n  }\n}\n\n.reset-employment-eligibility-modal-form {\n  .reset-employment-eligibility-modal-body {\n    .sub-heading {\n      display: flex;\n      flex-direction: row;\n      align-items: flex-start;\n      gap: 12px;\n      align-items: center;\n      margin-bottom: 12px;\n      .eligibility-unverified-icon {\n        color: red;\n        width: 24px;\n        height: 24px;\n      }\n      .sub-heading-text {\n        color: var(--Cod-Gray, #1c1c1c);\n        font-size: 16px;\n        font-weight: 700;\n      }\n    }\n    .sub-heading-message {\n      margin-bottom: 24px;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 150%; /* 24px */\n      letter-spacing: 0.15px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
